import * as types from '../constants/actionTypes';

export function createCommandLogEntry({command, status, data} = {}) {
    return { type: types.CREATE_COMMAND_LOGENTRY, command, status, data };
}
export function createLogEntry({logEntry, status, data} = {}) {
    return { type: types.CREATE_LOGENTRY, logEntry, status, data };
}

export function deleteLogEntry({logEntryID, status, data} = {}) {
    return { type: types.DELETE_LOGENTRY, logEntryID, status, data };
}
export function loadLogEntriesByTask({task, status, data} = {}) {
    return { type: types.LOAD_LOGENTRIES_BY_TASK, task, status, data };
}
export function loadLogEntriesByTimesheet({timesheet, status, data} = {}) {
    return { type: types.LOAD_LOGENTRIES_BY_TIMESHEET, timesheet, status, data };
}
export function loadLogEntriesByTimesheetTasks({timesheet, status, data} = {}) {
    return { type: types.LOAD_LOGENTRIES_BY_TIMESHEET_TASKS, timesheet, status, data };
}
export function loadLogEntriesOnDate({date, status, data} = {}) {
    return { type: types.LOAD_LOGENTRIES_ON_DATE, date, status, data };
}
export function loadLogEntriesOnDateForUser({date, user, status, data} = {}) {
    return { type: types.LOAD_LOGENTRIES_ON_DATE_FOR_USER, date, user, status, data };
}
export function loadLogentriesOnWeek({date, status, data} = {}) {
    return { type: types.LOAD_LOGENTRIES_ON_WEEK, date, status, data };
}
export function loadLogEntriesOnWeekForUser({date, user, status, data} = {}) {
    return { type: types.LOAD_LOGENTRIES_ON_WEEK_FOR_USER, date, user, status, data };
}
export function pmoCreateLogEntry({logEntry, status, data} = {}) {
    return { type: types.PMO_CREATE_LOGENTRY, logEntry, status, data };
}
export function pmoDeleteLogEntry({logEntryID, status, data} = {}) {
    return { type: types.PMO_DELETE_LOGENTRY, logEntryID, status, data };
}

export function pmoEditLogEntryStatus({status, data} = {}) {
    return { type: types.PMO_EDIT_LOGENTRY_STATUS, status, data };
}

export function pmoUpdateLogEntry({logEntry, status, data} = {}) {
    return { type: types.PMO_UPDATE_LOGENTRY, logEntry, status, data };
}
export function pmoUpdateLogEntryTask({original, logEntry, status, data} = {}) {
    return { type: types.PMO_UPDATE_LOGENTRY_TASK, original, logEntry, status, data };
}
export function setLoadingFlagForLogEntryState() {
    return { type: types.SET_LOADING_FLAG_FOR_LOGENTRY_STATE };
}
export function stopTimerLogEntry({logEntry, status, data} = {}) {
    return { type: types.STOP_TIMER_LOGENTRY, logEntry, status, data };
}
export function updateLogEntry({logEntry, status, data} = {}) {
    return { type: types.UPDATE_LOGENTRY, logEntry, status, data };
}
export function updateLogEntryTask({original, logEntry, status, data} = {}) {
    return { type: types.UPDATE_LOGENTRY_TASK, original, logEntry, status, data };
}



/** WEBPACK FOOTER **
 ** ./src/app/constants/logEntryActions.js
 **/